import { createStore, combineReducers } from "redux";
import * as globalReducer from "../redux-reducers/global-reducer";
import * as battleReducer from "../redux-reducers/battle-reducer";
import * as matchmakingReducer from "../redux-reducers/matchmaking-reducer";
import * as crewReducer from "../redux-reducers/crew-reducer";

export default function(data) {
  var reducer = combineReducers({
    ...globalReducer,
    ...battleReducer,
    ...matchmakingReducer,
    ...crewReducer
    //...anotherReducer,
  });

  var store;
  if (typeof window === "object") {
    store = createStore(
      reducer,
      data,
      window.devToolsExtension ? window.devToolsExtension() : undefined
    );
  } else {
    store = createStore(reducer, data);
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/init/create-store.js